<template lang="pug">
v-app(:class='section')
  v-toolbar.dark.light-blue.lighten-2(
    v-if='!isSignIn'
    extended
    fixed
    flat
  )
    v-fab-transition
      v-btn(icon, @click='goBack', v-if='!isStudyList')
        v-icon arrow_back
    v-spacer
    v-btn(icon, @click.prevent='exit')
      v-icon exit_to_app
    v-fab-transition
      v-btn.pink.lighten-2(
        @click='createStudy'
        v-if='isStudyList'
        fab
        dark
        absolute
        bottom
        right
      ): v-icon add
  main
    v-container(fluid)
      router-view
  v-snackbar(
    bottom
    left
    v-model='displaySnack'
  ) {{ snackMessage }}
  iframe.printFrame(ref='printFrame')
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  name: 'app',

  computed: {
    ...mapGetters([
      'section',
      'printContent',
      'displaySnack',
      'snackMessage',
    ]),

    isSignIn() {
      return this.section === 'sign-in';
    },

    isStudyList() {
      return this.section === 'study-list';
    },
  },

  methods: {
    ...mapActions({ logout: 'auth/logout' }),
    ...mapMutations(['setPrintContent']),

    createStudy() {
      this.$router.push({ name: 'NewStudy' });
    },

    goBack() {
      this.$router.go(-1);
    },

    async exit() {
      await this.logout();
      this.$router.replace({ name: 'SignIn' });
    },
  },

  watch: {
    printContent(value) {
      const { document, print } = this.$refs.printFrame.contentWindow;
      const body = document.querySelector('body');
      body.innerHTML = value;

      if (value) {
        document.querySelector('img').onload = () => {
          setTimeout(() => {
            print();
            this.setPrintContent('');
          }, 1000);
        };
      }
    },
  },
};
</script>

<style lang="less">
*, *::before, *::after {
  box-sizing: border-box;
}

.toolbar--fixed.toolbar--extended + main .container {
  min-height: ~"calc(100vh - 172px)";
}

.application--light {
  .input-group:not(.input-group--error) {
    .input-group__details::before {
      background-color: #DDD;
    }
  }

  .input-group:hover:not(.input-group--error) {
    .input-group__details::before {
      background-color: #CCC !important;
    }
  }
}

.dialog__content {
  z-index: 11;
}

.overlay {
  z-index: 10;
}

.menu__content {
  z-index: 100 !important;
}

.printFrame {
  border: none;
  height: 0;
  width: 0;
}
</style>



// WEBPACK FOOTER //
// src/app.vue